import React from "react";
import { Button, Modal, Toast, Badge, Picker, List } from "antd-mobile";
import { get } from "../../utils/request";
import cityData from "../data/cityData.js";
import arrayTreeFilter from "array-tree-filter";
import "./index.less";
import img460 from "./images/460.png";
import img466 from "./images/466.png";
import img483 from "./images/483.png";
import img492 from "./images/492.png";
import img496 from "./images/496.png";
import img500 from "./images/500.png";
import img502 from "./images/502.png";
import img541 from "./images/541.png";
import img543 from "./images/543.png";
import img549 from "./images/549.png";
import img550 from "./images/550.png";
import img551 from "./images/551.png";
import img552 from "./images/552.png";
import img560 from "./images/560.png";
import img561 from "./images/561.png";
import img562 from "./images/562.png";
import img563 from "./images/563.png";
import img564 from "./images/564.png";
import img566 from "./images/566.png";
import img567 from "./images/567.png";
import img568 from "./images/568.png";
import img569 from "./images/569.png";
import img570 from "./images/570.png";
import img573 from "./images/573.png";
import img574 from "./images/574.png";
import img575 from "./images/575.png";

function closest(el, selector) {
    const matchesSelector =
        el.matches ||
        el.webkitMatchesSelector ||
        el.mozMatchesSelector ||
        el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}

class RemoteVehicleDetail extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            id: "",
            carData: "",
            modal1: false,
            modal2: false,
            city: "",
            mobile: "",
            source: "",
            pickerValue: [],
            urlOps: {},
            imageSrc: {
                460: img460,
                466: img466,
                483: img483,
                492: img492,
                496: img496,
                500: img500,
                502: img502,
                541: img541,
                543: img543,
                549: img549,
                550: img550,
                551: img551,
                552: img552,
                560: img560,
                561: img561,
                562: img562,
                563: img563,
                564: img564,
                566: img566,
                567: img567,
                568: img568,
                569: img569,
                570: img570,
                573: img573,
                574: img574,
                575: img575
            },
        };
    }
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] = obj1[i].split("=")[1];
            }
            this.setState({
                id: ops.id,
            });
        }
    }
    onWrapTouchStart(e) {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, ".am-modal-content");
        if (!pNode) {
            e.preventDefault();
        }
    }

    // iOS 下 Modal 内 touch 事件链可能阻断 focus，用 touchEnd 强制触发
    // 安卓无此问题，只在 iOS 上执行
    handleInputTouchEnd = (e) => {
        if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            e.target.focus();
        }
    }

    getSel() {
        const value = this.state.pickerValue;
        if (!value) {
            return "";
        }
        const treeChildren = arrayTreeFilter(
            cityData,
            (c, level) => c.value === value[level]
        );
        return treeChildren.map((v) => v.label).join(",");
    }

    render() {
        const { id, imageSrc } = this.state;
        if (!id) {
            return <div></div>;
        }
        return (
            <div className="RemoteVehicleDetail Box">
                <div style={{ position: "relative" }}>
                    <img src={imageSrc[id]} />
                </div>
                <div className="telBox">
                    <Button
                        type="ghost"
                        inline
                        style={{ marginRight: "2%", width: "49%" }}
                        onClick={() => {
                            window.Countly.q.push([
                                "add_event",
                                {
                                    key: "CarRental_CarDetails_Tel_Ck",
                                    segmentation: {},
                                },
                            ]);
                            React.$hlInsight.track(
                                "CarRental_CarDetails_Tel_Ck",
                                {}
                            );
                            this.setState(
                                {
                                    // modal2: true,
                                    modal1: true,
                                    tapType: "call",
                                },
                                () => {
                                    if (this.state.mobile) {
                                        var dom =
                                            document.getElementById(
                                                "phoneNumber"
                                            );
                                        dom.value = this.state.mobile;
                                        dom.disabled = true;
                                    }
                                }
                            );
                        }}
                    >
                        电话咨询
                    </Button>
                    <Modal
                        visible={this.state.modal1}
                        transparent
                        maskClosable={false}
                        onClose={() => {
                            this.setState({
                                modal1: false,
                            });
                        }}
                        title=""
                        footer={[
                            {
                                text: "取消",
                                onPress: () => {
                                    window.Countly.q.push([
                                        "add_event",
                                        {
                                            key: "CarRental_CarDetails_SubscribeCancel_Ck",
                                            segmentation: {},
                                        },
                                    ]);

                                    React.$hlInsight.track(
                                        "CarRental_CarDetails_SubscribeCancel_Ck",
                                        {}
                                    );
                                    this.setState({
                                        modal1: false,
                                    });
                                },
                            },
                            {
                                text: "呼叫",
                                onPress: () => {
                                    window.Countly.q.push([
                                        "add_event",
                                        {
                                            key: "CarRental_CarDetails_SubscribeSubmit_Ck",
                                            segmentation: {},
                                        },
                                    ]);
                                    React.$hlInsight.track(
                                        "CarRental_CarDetails_SubscribeSubmit_Ck",
                                        {}
                                    );
                                    window.location.href = "tel:4008262266";
                                },
                            },
                        ]}
                        wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    >
                        <div style={{ color: "#1DA57A", fontSize: "20px" }}>
                            400-826-2266
                        </div>
                    </Modal>

                    <Button
                        type="primary"
                        inline
                        className="am-button-borderfix"
                        style={{ width: "49%" }}
                        onClick={() => {
                            window.Countly.q.push([
                                "add_event",
                                {
                                    key: "CarRental_CarDetails_Subscribe_Ck",
                                    segmentation: {},
                                },
                            ]);
                            React.$hlInsight.track(
                                "CarRental_CarDetails_Subscribe_Ck",
                                {}
                            );
                            this.setState(
                                {
                                    modal2: true,
                                },
                                () => {
                                    if (this.state.mobile) {
                                        var dom =
                                            document.getElementById(
                                                "phoneNumber"
                                            );
                                        dom.value = this.state.mobile;
                                        dom.disabled = true;
                                    }
                                }
                            );
                        }}
                    >
                        我要预约
                    </Button>
                    <Modal
                        visible={this.state.modal2}
                        transparent
                        maskClosable={false}
                        onClose={() => {
                            this.setState({ modal2: false });
                        }}
                        title={null}
                        footer={[]}
                        className="reserve-modal"
                    >
                        <div className="reserve-modal-inner">
                            <div className="reserve-modal-header">
                                <button
                                    className="reserve-modal-close"
                                    onClick={() => {
                                        this.setState({ modal2: false });
                                    }}
                                >
                                    ×
                                </button>
                                <span className="reserve-modal-title">我要预约</span>
                                <span className="reserve-modal-subtitle">留下信息，我们将尽快联系您</span>
                            </div>

                            <div className="reserve-modal-body">
                                {/* 姓名 */}
                                <div className="modal-form-item">
                                    <div className="modal-form-label">
                                        <span className="modal-required">*</span>姓名
                                    </div>
                                    <input
                                        id="userName"
                                        type="text"
                                        maxLength="10"
                                        placeholder="请输入您的姓名"
                                        className="modal-form-input"
                                        onTouchEnd={this.handleInputTouchEnd}
                                    />
                                </div>

                                {/* 手机号 */}
                                <div className="modal-form-item">
                                    <div className="modal-form-label">
                                        <span className="modal-required">*</span>手机号
                                    </div>
                                    <input
                                        id="phoneNumber"
                                        type="tel"
                                        maxLength="11"
                                        placeholder="请输入您的手机号"
                                        className="modal-form-input"
                                        onTouchEnd={this.handleInputTouchEnd}
                                    />
                                </div>

                                {/* 用车地 */}
                                <div className="modal-form-item">
                                    <div className="modal-form-label">
                                        <span className="modal-required">*</span>用车城市
                                    </div>
                                    <div className="modal-city-wrap">
                                        <Picker
                                            extra="请选择省市"
                                            cols="2"
                                            visible={this.state.visible}
                                            data={cityData}
                                            value={this.state.pickerValue}
                                            onChange={(v) =>
                                                this.setState({ pickerValue: v })
                                            }
                                            onOk={() =>
                                                this.setState({ visible: false })
                                            }
                                            onDismiss={() =>
                                                this.setState({ visible: false })
                                            }
                                        >
                                            <List.Item
                                                extra={this.getSel()}
                                                onClick={() =>
                                                    this.setState({ visible: true })
                                                }
                                                className="modal-city-item"
                                            ></List.Item>
                                        </Picker>
                                    </div>
                                </div>
                            </div>

                            <div className="reserve-modal-footer">
                                <button
                                    className="modal-btn-submit"
                                    onClick={() => {
                                        const url =
                                            "/gateway/huilianCust/hlThreadcs/addHlThreadCallBack";
                                        var userName =
                                            document.getElementById("userName").value;
                                        var phoneNumber =
                                            document.getElementById("phoneNumber").value;
                                        if (!userName) {
                                            Toast.info("请填写您的姓名，方便我们联系您", 2);
                                            return;
                                        }
                                        if (!phoneNumber) {
                                            Toast.info("请填写您的手机号，方便我们回电", 2);
                                            return;
                                        }
                                        if (
                                            phoneNumber[0] != 1 ||
                                            phoneNumber.length != 11
                                        ) {
                                            Toast.info("手机号格式不正确，请重新填写", 2);
                                            return;
                                        }
                                        if (this.state.pickerValue.length === 0) {
                                            Toast.info("请选择您的用车城市", 2);
                                            return;
                                        }
                                        var resourceStr = this.state.mobile
                                            ? "转介绍预约"
                                            : "客户预约";
                                        get({
                                            url,
                                            method: "GET",
                                            data: {
                                                companyName: userName,
                                                carTypes: this.state.carData.type,
                                                otherNeed: this.state.carData.name,
                                                organizationName:
                                                    this.state.pickerValue[1].replace(
                                                        "市",
                                                        ""
                                                    ),
                                                linkManName: userName,
                                                linkMobileNumber: phoneNumber,
                                                tierType: 4,
                                                resource:
                                                    this.state.source &&
                                                    this.state.source === "transfar"
                                                        ? "传化渠道"
                                                        : resourceStr,
                                                province: this.state.pickerValue[0],
                                                city: this.state.pickerValue[1],
                                            },
                                        }).then(
                                            (res) => {
                                                if (res.result === "success") {
                                                    this.setState({ modal2: false });
                                                    Toast.info("提交成功", 1);
                                                } else {
                                                    Toast.info(res.msg, 1);
                                                }
                                            },
                                            (res) => {
                                                Toast.info(res.msg, 1);
                                            }
                                        );
                                    }}
                                >
                                    提交
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default RemoteVehicleDetail;



// WEBPACK FOOTER //
// ./src/marketingOnline/vehicleDetail/index.js